var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QFooter',{attrs:{"elevated":""}},[_c('Menu',{staticClass:"q-py-sm"}),(_vm.$q.screen.lt.md)?_c('StatusBar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }